// import React, { useState, useEffect, useRef } from 'react';
// import {
//     Box,
//     Button,
//     Card,
//     CardContent,
//     CardHeader,
//     Typography,
//     Grid,
//     CircularProgress,
//     LinearProgress,
//     List,
//     ListItem,
//     ListItemIcon,
//     ListItemText,
//     Collapse,
//     Chip,
//     Paper,
//     Divider,
//     Alert,
//     AlertTitle
// } from '@mui/material';
// import { styled, alpha, useTheme } from '@mui/material/styles';
// import {
//     QuizOutlined,
//     ArrowForward,
//     Replay,
//     AccessTime,
//     EmojiEventsOutlined,
//     CheckCircleOutline,
//     HighlightOff,
//     SchoolOutlined,
//     ExpandMore,
//     ExpandLess,
//     CategoryOutlined,
//     LightbulbOutlined,
//     RefreshOutlined,
//     InfoOutlined,
//     CelebrationOutlined,
//     AlarmOnOutlined,
//     AlarmOffOutlined,
//     Timer
// } from '@mui/icons-material';

// // Enhanced Mock Data with Categories and Explanations
// const mockQuestions = [
//     {
//         id: 1,
//         question: 'What is the capital of France?',
//         options: ['London', 'Paris', 'Berlin', 'Madrid'],
//         correctAnswer: 'Paris',
//         category: 'Geography',
//         explanation: 'Paris, France\'s capital, is a major European city and a global center for art, fashion, gastronomy and culture. Its 19th-century cityscape is crisscrossed by wide boulevards and the River Seine.'
//     },
//     {
//         id: 2,
//         question: 'Who wrote the play "Hamlet"?',
//         options: ['Charles Dickens', 'William Shakespeare', 'Leo Tolstoy', 'Mark Twain'],
//         correctAnswer: 'William Shakespeare',
//         category: 'Literature',
//         explanation: '"Hamlet" is a tragedy written by William Shakespeare sometime between 1599 and 1601. It is Shakespeare\'s longest play and is ranked among the most powerful and influential tragedies in English literature.'
//     },
//     {
//         id: 3,
//         question: 'What is the largest planet in our solar system?',
//         options: ['Earth', 'Mars', 'Jupiter', 'Saturn'],
//         correctAnswer: 'Jupiter',
//         category: 'Science - Astronomy',
//         explanation: 'Jupiter is the fifth planet from the Sun and the largest in the Solar System. It is a gas giant with a mass more than two and a half times that of all the other planets in the Solar System combined.'
//     },
//     {
//         id: 4,
//         question: 'What is the chemical symbol for water?',
//         options: ['O2', 'H2O', 'CO2', 'NaCl'],
//         correctAnswer: 'H2O',
//         category: 'Science - Chemistry',
//         explanation: 'H2O is the chemical formula for water, meaning that one molecule of water is composed of two hydrogen atoms and one oxygen atom.'
//     },
//     {
//         id: 5,
//         question: 'Which is the highest mountain in the world?',
//         options: ['K2', 'Kangchenjunga', 'Mount Everest', 'Lhotse'],
//         correctAnswer: 'Mount Everest',
//         category: 'Geography',
//         explanation: 'Mount Everest, located in the Himalayas, is Earth\'s highest mountain above sea level, with its peak at 8,848.86 metres (29,031.7 ft).'
//     },
//     {
//         id: 6,
//         question: 'What gas do plants absorb from the atmosphere for photosynthesis?',
//         options: ['Oxygen', 'Nitrogen', 'Carbon Dioxide', 'Hydrogen'],
//         correctAnswer: 'Carbon Dioxide',
//         category: 'Science - Biology',
//         explanation: 'Plants absorb carbon dioxide (CO2) from the atmosphere through small pores in their leaves called stomata, using it in the process of photosynthesis to create sugars for energy.'
//     },
//     {
//         id: 7,
//         question: 'In which year did World War II end?',
//         options: ['1942', '1945', '1950', '1939'],
//         correctAnswer: '1945',
//         category: 'History',
//         explanation: 'World War II, a global conflict that lasted from 1939 to 1945, officially ended on September 2, 1945, when Japan formally surrendered to the Allies aboard the USS Missouri in Tokyo Bay.'
//     }
// ];

// const TOTAL_QUESTIONS = mockQuestions.length;
// const QUESTION_DURATION = 120; // 2 minutes per question
// const QUIZ_AVAILABILITY_DURATION = 86400; // 24 hours
// const TOTAL_REQUIRED_FOR_CERTIFICATE = 4;

// // --- Styled Components ---
// const StyledAppContainer = styled(Box)(({ theme }) => ({
//     minHeight: '100vh',
//     padding: theme.spacing(2),
//     background: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',
//     color: theme.palette.text.primary,
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     [theme.breakpoints.up('sm')]: {
//         padding: theme.spacing(4),
//     },
// }));

// const StyledQuizCard = styled(Card)(({ theme }) => ({
//     background: 'rgba(255, 255, 255, 0.9)',
//     backdropFilter: 'blur(10px)',
//     borderRadius: theme.shape.borderRadius * 3,
//     boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)',
//     transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//     '&:hover': {
//         transform: 'translateY(-5px)',
//         boxShadow: '0 18px 36px rgba(0, 0, 0, 0.2)',
//     },
//     maxWidth: 800,
//     margin: '0 auto',
// }));

// const StyledQuizCardHeader = styled(CardHeader)(({ theme }) => ({
//     padding: theme.spacing(3, 4),
//     borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//     '& .MuiCardHeader-avatar': {
//         marginRight: theme.spacing(2),
//     },
//     '& .MuiCardHeader-title': {
//         fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//         fontWeight: 700,
//         color: theme.palette.primary.dark,
//     },
//     '& .MuiCardHeader-subheader': {
//         fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
//         color: theme.palette.text.secondary,
//         marginTop: theme.spacing(0.5),
//     },
// }));

// const OptionButton = styled(Button)(({ theme, selected, isCorrect, quizCompleted, showFeedback }) => {
//     let backgroundColor = theme.palette.grey[200];
//     let color = theme.palette.text.primary;
//     let hoverBackgroundColor = theme.palette.grey[300];

//     if (showFeedback) {
//         if (isCorrect) {
//             backgroundColor = alpha(theme.palette.success.light, 0.8);
//             color = theme.palette.success.contrastText;
//             hoverBackgroundColor = theme.palette.success.main;
//         } else if (selected) {
//             backgroundColor = alpha(theme.palette.error.light, 0.8);
//             color = theme.palette.error.contrastText;
//             hoverBackgroundColor = theme.palette.error.main;
//         } else {
//             backgroundColor = theme.palette.grey[300];
//             color = theme.palette.text.secondary;
//         }
//     } else if (selected) {
//         backgroundColor = alpha(theme.palette.primary.light, 0.7);
//         color = theme.palette.primary.contrastText;
//         hoverBackgroundColor = theme.palette.primary.main;
//     }

//     return {
//         width: '100%',
//         margin: theme.spacing(1, 0),
//         textTransform: 'none',
//         borderRadius: theme.shape.borderRadius * 1.5,
//         fontSize: 'clamp(1rem, 3vw, 1.1rem)',
//         fontWeight: 500,
//         padding: theme.spacing(1.5, 2.5),
//         justifyContent: 'flex-start',
//         transition: 'all 0.25s ease-in-out',
//         backgroundColor: backgroundColor,
//         color: color,
//         border: `2px solid transparent`,
//         '&:hover': {
//             backgroundColor: hoverBackgroundColor,
//             transform: 'scale(1.02)',
//             boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.15)}`,
//         },
//         opacity: quizCompleted && !selected && !isCorrect ? 0.6 : 1,
//         pointerEvents: showFeedback ? 'none' : 'auto',
//         boxShadow: selected ? `0 6px 12px ${alpha(theme.palette.common.black, 0.1)}` : `0 2px 4px ${alpha(theme.palette.common.black, 0.05)}`,
//     };
// });

// const StyledActionButton = styled(Button)(({ theme, color = 'primary' }) => ({
//     padding: theme.spacing(1.5, 3),
//     borderRadius: theme.shape.borderRadius * 1.5,
//     fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
//     fontWeight: 'bold',
//     transition: 'all 0.3s ease',
//     boxShadow: `0 4px 8px ${alpha(theme.palette[color]?.main || theme.palette.primary.main, 0.2)}`,
//     '&:hover': {
//         boxShadow: `0 6px 12px ${alpha(theme.palette[color]?.main || theme.palette.primary.main, 0.3)}`,
//         transform: 'translateY(-2px)',
//     },
// }));

// const StatsCard = styled(Paper)(({ theme }) => ({
//     backgroundColor: alpha(theme.palette.background.paper, 0.85),
//     backdropFilter: 'blur(8px)',
//     color: theme.palette.text.primary,
//     borderRadius: theme.shape.borderRadius * 2.5,
//     padding: theme.spacing(3),
//     boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
//     border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
// }));

// // --- QuizApp Component ---
// const QuizApp = () => {
//     const theme = useTheme();
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//     const [answers, setAnswers] = useState({});
//     const [quizCompleted, setQuizCompleted] = useState(false);
//     const [timeLeftToday, setTimeLeftToday] = useState(QUIZ_AVAILABILITY_DURATION);
//     const [showFeedback, setShowFeedback] = useState(false);
//     const [openResult, setOpenResult] = useState({});
//     const [questionTimer, setQuestionTimer] = useState(QUESTION_DURATION);
//     const [isQuizActive, setIsQuizActive] = useState(false);
//     const availabilityTimerRef = useRef(null);
//     const questionTimerRef = useRef(null);
//     const [currentQuestionStartTime, setCurrentQuestionStartTime] = useState(null);


//     // Load completedQuizzes from localStorage
//     const [completedQuizzes, setCompletedQuizzes] = useState(() => {
//         const savedProgress = localStorage.getItem('quizAppCompletedQuizzes');
//         return savedProgress ? parseInt(savedProgress, 10) : 0;
//     });

//     // Save completedQuizzes to localStorage
//     useEffect(() => {
//         localStorage.setItem('quizAppCompletedQuizzes', completedQuizzes.toString());
//     }, [completedQuizzes]);

//     useEffect(() => {
//         // Set up the daily availability timer
//         availabilityTimerRef.current = setInterval(() => {
//             setTimeLeftToday((prev) => (prev > 0 ? prev - 1 : 0));
//         }, 1000);

//         return () => {
//             clearInterval(availabilityTimerRef.current);
//             clearInterval(questionTimerRef.current);
//             document.body.style.userSelect = '';
//             document.body.removeEventListener('contextmenu', preventContextMenu);
//         };
//     }, []);

//     useEffect(() => {
//         // If quiz is active, start the question timer
//         if (isQuizActive && questionTimer > 0) {
//             questionTimerRef.current = setInterval(() => {
//                 setQuestionTimer((prev) => prev - 1);
//             }, 1000);
//         } else if (isQuizActive && questionTimer === 0) {
//             // Time's up for the question
//             handleNextQuestion(); // Go to the next question
//         }
//         return () => clearInterval(questionTimerRef.current);
//     }, [isQuizActive, questionTimer, currentQuestionIndex]);


//     const startQuiz = () => {
//         setIsQuizActive(true);
//         setQuestionTimer(QUESTION_DURATION);
//         setCurrentQuestionStartTime(new Date());
//     };

//     const handleAnswer = (option) => {
//         if (isQuizActive && !showFeedback) {
//             const currentQ = mockQuestions[currentQuestionIndex];
//             setAnswers((prev) => ({ ...prev, [currentQ.id]: option }));
//             setShowFeedback(true);
//         }
//     };

//     const handleNextQuestion = () => {
//         if (showFeedback) {
//             setShowFeedback(false);
//             if (currentQuestionIndex < TOTAL_QUESTIONS - 1) {
//                 setCurrentQuestionIndex((i) => i + 1);
//                 setQuestionTimer(QUESTION_DURATION); // Reset timer for next question
//                 setCurrentQuestionStartTime(new Date());
//             } else {
//                 setQuizCompleted(true);
//                 setIsQuizActive(false);
//                 clearInterval(questionTimerRef.current);
//                 setCompletedQuizzes((prev) => prev + 1);
//             }
//         }
//     };


//     const handleRestartQuiz = () => {
//         setCurrentQuestionIndex(0);
//         setAnswers({});
//         setQuizCompleted(false);
//         setShowFeedback(false);
//         setQuestionTimer(QUESTION_DURATION);
//         setIsQuizActive(true);
//         setCurrentQuestionStartTime(new Date());
//     };

//     const handleResultToggle = (id) => {
//         setOpenResult(prev => ({ ...prev, [id]: !prev[id] }));
//     };

//     const formatTime = (sec) => {
//         const hrs = String(Math.floor(sec / 3600)).padStart(2, '0');
//         const min = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
//         const secStr = String(sec % 60).padStart(2, '0');
//         return `${hrs}:${min}:${secStr}`;
//     };

//     const currentQ = mockQuestions[currentQuestionIndex];
//     const selectedAnswer = answers[currentQ?.id];

//     const correctAnswersCount = mockQuestions.reduce((count, q) => {
//         return answers[q.id] === q.correctAnswer ? count + 1 : count;
//     }, 0);

//     const questionProgress = ((currentQuestionIndex + 1) / TOTAL_QUESTIONS) * 100;
//     const certificateProgress = (completedQuizzes / TOTAL_REQUIRED_FOR_CERTIFICATE) * 100;
//     const isQuizAvailable = timeLeftToday > 0;

//         // --- Disable text selection and context menu ---
//     const preventContextMenu = (e) => e.preventDefault();
//     useEffect(() => {
//         document.body.style.userSelect = 'none';
//         document.body.addEventListener('contextmenu', preventContextMenu);
//         return () => {
//             document.body.style.userSelect = '';
//             document.body.removeEventListener('contextmenu', preventContextMenu);
//         };
//     }, []);

//     return (
//         <StyledAppContainer>
//             <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
//                 {/* Main Quiz Card */}
//                 <Grid item xs={12} md={7} lg={8}>
//                     <StyledQuizCard>
//                         <StyledQuizCardHeader
//                             avatar={<QuizOutlined sx={{ color: 'primary.main', fontSize: { xs: 40, sm: 50 } }} />}
//                             title="Knowledge Quest Daily"
//                             subheader="Sharpen your mind, one question at a time!"
//                         />
//                         <CardContent sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
//                             {isQuizAvailable ? (
//                                 !isQuizActive ? (
//                                     <Box textAlign="center">
//                                         <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: 'text.secondary', mb: 3, fontSize: 'clamp(1.1rem, 4vw, 1.5rem)' }}>
//                                             Ready for today's challenge?
//                                         </Typography>
//                                         <StyledActionButton
//                                             variant="contained"
//                                             color="primary"
//                                             startIcon={<AlarmOnOutlined />}
//                                             onClick={startQuiz}
//                                         >
//                                             Start Today's Quiz
//                                         </StyledActionButton>
//                                         <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//                                             Each question has {Math.floor(QUESTION_DURATION / 60)} minutes to answer.
//                                         </Typography>
//                                     </Box>
//                                 ) : !quizCompleted ? (
//                                     <Box>
//                                         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                                             <Typography variant="h6" sx={{ color: 'text.secondary', fontSize: 'clamp(1rem, 3vw, 1.1rem)' }}>
//                                                 Question {currentQuestionIndex + 1} of {TOTAL_QUESTIONS}
//                                             </Typography>
//                                             <Chip
//                                                 icon={<CategoryOutlined />}
//                                                 label={currentQ.category}
//                                                 color="secondary"
//                                                 size="small"
//                                                 sx={{ fontWeight: 'medium' }}
//                                             />
//                                         </Box>
//                                         <LinearProgress
//                                             variant="determinate"
//                                             value={questionProgress}
//                                             sx={{ height: 10, borderRadius: 5, mb: 3, bgcolor: alpha(theme.palette.primary.light, 0.3), '& .MuiLinearProgress-bar': { bgcolor: theme.palette.primary.main } }}
//                                         />
//                                         <Typography variant="h4" gutterBottom sx={{ fontWeight: 'medium', lineHeight: 1.4, mb: 3, fontSize: 'clamp(1.2rem, 5vw, 1.75rem)' }}>
//                                             {currentQ.question}
//                                         </Typography>
//                                         <Box mb={3}>
//                                             {currentQ.options.map((opt, i) => (
//                                                 <OptionButton
//                                                     key={i}
//                                                     selected={selectedAnswer === opt}
//                                                     onClick={() => handleAnswer(opt)}
//                                                     quizCompleted={quizCompleted}
//                                                     isCorrect={opt === currentQ.correctAnswer}
//                                                     showFeedback={showFeedback}
//                                                     disabled={questionTimer === 0}
//                                                 >
//                                                     {opt}
//                                                 </OptionButton>
//                                             ))}
//                                         </Box>
//                                         <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
//                                             <StyledActionButton
//                                                 variant="outlined"
//                                                 color="warning"
//                                                 startIcon={<RefreshOutlined />}
//                                                 onClick={handleRestartQuiz}
//                                                 disabled={quizCompleted || questionTimer === 0}
//                                             >
//                                                 Restart Quiz
//                                             </StyledActionButton>
//                                             <StyledActionButton
//                                                 onClick={handleNextQuestion}
//                                                 disabled={!showFeedback || questionTimer === 0}
//                                                 variant="contained"
//                                                 color="primary"
//                                                 endIcon={<ArrowForward />}
//                                             >
//                                                 {currentQuestionIndex < TOTAL_QUESTIONS - 1 ? 'Next Question' : 'Finish Quiz'}
//                                             </StyledActionButton>
//                                         </Box>
//                                         {questionTimer > 0 && (
//                                             <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, textAlign: 'right' }}>
//                                                 Time Remaining: <Timer sx={{width: 16, height: 16, verticalAlign: 'middle', marginRight: 2}}/> {Math.floor(questionTimer / 60)}:{String(questionTimer % 60).padStart(2, '0')}
//                                             </Typography>
//                                         )}
//                                         {questionTimer === 0 && (
//                                             <Alert severity="warning" sx={{ mt: 2 }}>
//                                                 Time's up!  The answer to this question will be marked incorrect.
//                                             </Alert>
//                                         )}
//                                     </Box>
//                                 ) : (
//                                     // --- Quiz Completed View ---
//                                     <Box sx={{ textAlign: 'center', py: 3 }}>
//                                         <EmojiEventsOutlined sx={{ fontSize: {xs: 70, sm: 100}, color: 'warning.main', mb: 2 }} />
//                                         <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'primary.dark', mb: 1, fontSize: 'clamp(1.8rem, 5vw, 2.5rem)' }}>
//                                             Quiz Finished!
//                                         </Typography>
//                                         <Typography variant="h5" sx={{ color: 'text.secondary', mb: 3, fontSize: 'clamp(1.1rem, 4vw, 1.5rem)' }}>
//                                             You scored {correctAnswersCount} out of {TOTAL_QUESTIONS}!
//                                         </Typography>

//                                         <Divider sx={{ my: 3 }}><Chip label="Detailed Results" icon={<InfoOutlined />} /></Divider>

//                                         <List sx={{ maxHeight: 400, overflow: 'auto', pr:1 }}>
//                                             {mockQuestions.map((q) => (
//                                                 <Card key={q.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 1, bgcolor: alpha(theme.palette.background.default, 0.5) }}>
//                                                     <ListItem button onClick={() => handleResultToggle(q.id)} sx={{ py: 1.5 }}>
//                                                         <ListItemIcon sx={{minWidth: 40}}>
//                                                             {answers[q.id] === q.correctAnswer ? (
//                                                                 <CheckCircleOutline color="success" sx={{fontSize: 28}} />
//                                                             ) : (
//                                                                 <HighlightOff color="error" sx={{fontSize: 28}}/>
//                                                             )}
//                                                         </ListItemIcon>
//                                                         <ListItemText
//                                                             primary={<Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>{q.question}</Typography>}
//                                                             secondaryTypographyProps={{component: 'div'}}
//                                                             secondary={
//                                                                 <Typography variant="body2" color="textSecondary">
//                                                                     Your Answer: <Typography component="span" fontWeight="bold" color={answers[q.id] === q.correctAnswer ? "success.main" : "error.main"}>{answers[q.id] || "Not answered"}</Typography>
//                                                                 </Typography>
//                                                             }
//                                                         />
//                                                         {openResult[q.id] ? <ExpandLess /> : <ExpandMore />}
//                                                     </ListItem>
//                                                     <Collapse in={openResult[q.id]} timeout="auto" unmountOnExit>
//                                                         <CardContent sx={{ pt: 0, borderTop: `1px solid ${alpha(theme.palette.divider,0.5)}`, mt:1}}>
//                                                             <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
//                                                                 Correct Answer: <Typography component="span" fontWeight="bold" color="primary.main">{q.correctAnswer}</Typography>
//                                                             </Typography>
//                                                             <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic', color: 'text.secondary' }}>
//                                                                 <LightbulbOutlined sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5, color: 'secondary.main' }} />
//                                                                 Explanation: {q.explanation}
//                                                             </Typography>
//                                                         </CardContent>
//                                                     </Collapse>
//                                                 </Card>
//                                             ))}
//                                         </List>

//                                         <StyledActionButton
//                                             startIcon={<Replay />}
//                                             onClick={() => window.location.reload()} // Simple reload for "Try Again"
//                                             variant="outlined"
//                                             color="secondary"
//                                             sx={{ mt: 4 }}
//                                         >
//                                             Try Again Tomorrow
//                                         </StyledActionButton>
//                                     </Box>
//                                 )
//                             ) : (
//                                 <Box textAlign="center" py={4}>
//                                     <AlarmOffOutlined sx={{ fontSize: {xs: 70, sm: 100}, color: 'error.main', mb: 2 }} />
//                                     <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'error.dark', mb: 2, fontSize: 'clamp(1.5rem, 5vw, 2rem)' }}>
//                                         Today's Quiz Missed!
//                                     </Typography>
//                                     <Typography variant="body1" color="text.secondary" sx={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}>
//                                         The daily quiz was available for 24 hours. Please come back tomorrow for the next quiz.
//                                     </Typography>
//                                 </Box>
//                             )}
//                         </CardContent>
//                     </StyledQuizCard>
//                 </Grid>

//                 {/* Sidebar / Stats */}
//                 <Grid item xs={12} md={5} lg={4}>
//                     <StatsCard>
//                         <Box display="flex" alignItems="center" gap={1.5} sx={{ mb: 3, pb: 2, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.7)}` }}>
//                             <AccessTime sx={{ color: 'secondary.main', fontSize: {xs: 28, sm:32} }} />
//                             <Typography variant="h6" sx={{ fontWeight: 'medium', fontSize: 'clamp(1.1rem, 3vw, 1.25rem)' }}>Time Left Today</Typography>
//                             <Typography variant="h6" sx={{ ml: 'auto', fontWeight: 'bold', color: timeLeftToday > 0 ? 'secondary.dark' : 'error.dark', fontSize: 'clamp(1.1rem, 3vw, 1.25rem)' }}>
//                                 {formatTime(Math.max(0, timeLeftToday))}
//                             </Typography>
//                         </Box>

//                         <Box textAlign="center">
//                             <Typography variant="h6" gutterBottom sx={{ fontWeight: 'medium', color: 'text.primary', mb: 2, fontSize: 'clamp(1.1rem, 3vw, 1.25rem)' }}>
//                                 Certificate Progress
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
//                                 <CircularProgress
//                                     variant="determinate"
//                                     value={Math.min(certificateProgress, 100)} // Cap at 100%
//                                     size={160}
//                                     thickness={6}
//                                     sx={{ color: 'warning.main', circle: { strokeLinecap: 'round' } }}
//                                 />
//                                  <CircularProgress // Background track
//                                     variant="determinate"
//                                     value={100}
//                                     size={160}
//                                     thickness={6}
//                                     sx={{
//                                         color: alpha(theme.palette.warning.light, 0.2),
//                                         position: 'absolute',
//                                         left: 0,
//                                         zIndex: -1,
//                                         circle: { strokeLinecap: 'round' }
//                                     }}
//                                 />
//                                 <Box
//                                     sx={{
//                                         top: 0, left: 0, bottom: 0, right: 0,
//                                         position: 'absolute',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         flexDirection: 'column',
//                                     }}
//                                 >
//                                     <SchoolOutlined sx={{ color: 'warning.dark', fontSize: 30, mb: 0.5 }} />
//                                     <Typography variant="h4" component="div" color="text.primary" sx={{ fontWeight: 'bold', fontSize: 'clamp(1.5rem, 5vw, 2rem)' }}>
//                                         {`${Math.round(Math.min(certificateProgress, 100))}%`}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                             <Typography variant="subtitle1" sx={{ mt: 1, fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)', color: 'text.secondary' }}>
//                                 {completedQuizzes} / {TOTAL_REQUIRED_FOR_CERTIFICATE} Quizzes Completed
//                             </Typography>
//                              {completedQuizzes < TOTAL_REQUIRED_FOR_CERTIFICATE &&
//                                 <Typography variant="body2" sx={{mt:1, color: theme.palette.text.hint }}>
//                                     Complete {TOTAL_REQUIRED_FOR_CERTIFICATE - completedQuizzes} more quizzes to earn your certificate!
//                                 </Typography>
//                             }
//                         </Box>
//                     </StatsCard>

//                        <Grid item xs={12}>
//                               <Typography variant="h6" sx={{ color: 'text.secondary', mt: 4, fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}>
//                                         Quizzes for certificate: {completedQuizzes} / {TOTAL_REQUIRED_FOR_CERTIFICATE}
//                                     </Typography>

//                        {completedQuizzes >= TOTAL_REQUIRED_FOR_CERTIFICATE && (
//                                         <Alert
//                                             severity="success"
//                                             icon={<CelebrationOutlined fontSize="inherit" />}
//                                             sx={{
//                                                 mt: 3,
//                                                 borderRadius: 2,
//                                                 p: 2,
//                                                 background: `linear-gradient(135deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 100%)`,
//                                                 color: theme.palette.success.contrastText
//                                             }}
//                                         >
//                                             <AlertTitle sx={{fontWeight: 'bold'}}>Certificate Unlocked!</AlertTitle>
//                                             Congratulations! You've shown amazing dedication and earned your achievement. Keep learning!
//                                         </Alert>
//                                     )}
//                 </Grid>
//                 </Grid>

//             </Grid>
//         </StyledAppContainer>
//     );
// };

// export default QuizApp;


// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import {
//     Box, Button, Card, CardContent, CardHeader, Typography, Grid, CircularProgress,
//     LinearProgress, List, ListItem, ListItemIcon, ListItemText, Collapse, Chip,
//     Paper, Divider, Alert, AlertTitle, Avatar, Badge, Tooltip, IconButton
// } from '@mui/material';
// import { styled, alpha, useTheme } from '@mui/material/styles';
// import {
//     Quiz, ArrowForward, Replay, AccessTime, EmojiEvents, CheckCircle, Close,
//     School, ExpandMore, ExpandLess, Category, Lightbulb, Refresh, Info,
//     Celebration, AlarmOn, AlarmOff, Timer, Star, HelpOutline, LockClock,
//     TrendingUp, Leaderboard, Psychology, Diamond
// } from '@mui/icons-material';

// const QUESTION_DURATION = 120;
// const QUIZ_AVAILABILITY_DURATION = 86400; 
// const TOTAL_REQUIRED_FOR_CERTIFICATE = 4;
// const PASSING_SCORE = 0.7;
// const difficultyLevels = {
//     easy: { color: 'success', points: 10 },
//     medium: { color: 'warning', points: 20 },
//     hard: { color: 'error', points: 30 }
// };

// const mockQuestions = [
//     {
//         id: 1,
//         question: 'What is the capital of France?',
//         options: ['London', 'Paris', 'Berlin', 'Madrid'],
//         correctAnswer: 'Paris',
//         category: 'Geography',
//         difficulty: 'easy',
//         explanation: 'Paris is France\'s capital and a global center for art, fashion, and culture.',
//         funFact: 'Paris is known as the "City of Light" because it was one of the first cities to use gas street lighting.'
//     },
//     {
//         id: 2,
//         question: 'Who wrote "Hamlet"?',
//         options: ['Charles Dickens', 'William Shakespeare', 'Leo Tolstoy', 'Mark Twain'],
//         correctAnswer: 'William Shakespeare',
//         category: 'Literature',
//         difficulty: 'medium',
//         explanation: '"Hamlet" is a tragedy by William Shakespeare, written between 1599-1601.',
//         funFact: 'Hamlet is Shakespeare\'s longest play with over 4,000 lines!'
//     },
//     {
//         id: 3,
//         question: 'What is the largest planet in our solar system?',
//         options: ['Earth', 'Mars', 'Jupiter', 'Saturn'],
//         correctAnswer: 'Jupiter',
//         category: 'Astronomy',
//         difficulty: 'easy',
//         explanation: 'Jupiter is the largest planet with a mass 2.5x all other planets combined.',
//         funFact: 'Jupiter\'s Great Red Spot is a giant storm bigger than Earth!'
//     },
//     {
//         id: 4,
//         question: 'What is the chemical symbol for water?',
//         options: ['O2', 'H2O', 'CO2', 'NaCl'],
//         correctAnswer: 'H2O',
//         category: 'Chemistry',
//         difficulty: 'easy',
//         explanation: 'H2O means one molecule has two hydrogen atoms and one oxygen atom.',
//         funFact: 'Water is the only substance found naturally in all three states (solid, liquid, gas) on Earth.'
//     },
//     {
//         id: 5,
//         question: 'Which is the highest mountain in the world?',
//         options: ['K2', 'Kangchenjunga', 'Mount Everest', 'Lhotse'],
//         correctAnswer: 'Mount Everest',
//         category: 'Geography',
//         difficulty: 'medium',
//         explanation: 'Mount Everest is Earth\'s highest mountain above sea level at 8,848 meters.',
//         funFact: 'Everest grows about 4mm taller each year due to tectonic plate movement.'
//     },
//     {
//         id: 6,
//         question: 'What gas do plants absorb for photosynthesis?',
//         options: ['Oxygen', 'Nitrogen', 'Carbon Dioxide', 'Hydrogen'],
//         correctAnswer: 'Carbon Dioxide',
//         category: 'Biology',
//         difficulty: 'medium',
//         explanation: 'Plants absorb CO2 through stomata to create sugars for energy.',
//         funFact: 'A single tree can absorb about 48 pounds of CO2 per year!'
//     },
//     {
//         id: 7,
//         question: 'In which year did World War II end?',
//         options: ['1942', '1945', '1950', '1939'],
//         correctAnswer: '1945',
//         category: 'History',
//         difficulty: 'hard',
//         explanation: 'WWII lasted from 1939-1945, ending with Japan\'s surrender on Sept 2, 1945.',
//         funFact: 'The war resulted in 70-85 million fatalities, about 3% of the world population.'
//     }
// ];

// // ========== Styled Components ==========
// const AppContainer = styled(Box)(({ theme }) => ({
//     minHeight: '100vh',
//     padding: theme.spacing(2),
//     // background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//         background: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',

//     [theme.breakpoints.up('sm')]: { padding: theme.spacing(4) },
// }));

// const QuizCard = styled(Card)(({ theme }) => ({
//     background: 'rgba(255, 255, 255, 0.95)',
//     backdropFilter: 'blur(10px)',
//     borderRadius: theme.shape.borderRadius * 3,
//     boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)',
//     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//     '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 18px 36px rgba(0, 0, 0, 0.2)' },
//     maxWidth: 800,
//     margin: '0 auto',
// }));

// const QuizHeader = styled(CardHeader)(({ theme }) => ({
//     padding: theme.spacing(3, 4),
//     borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
//     '& .MuiCardHeader-title': {
//         fontSize: 'clamp(1.5rem, 4vw, 2rem)',
//         fontWeight: 700,
//         color: theme.palette.primary.dark,
//     },
//     '& .MuiCardHeader-subheader': {
//         fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
//         color: theme.palette.text.secondary,
//     },
// }));

// const OptionButton = styled(Button, {
//     shouldForwardProp: (prop) => !['selected', 'isCorrect', 'quizCompleted', 'showFeedback'].includes(prop)
// })(({ theme, selected, isCorrect, quizCompleted, showFeedback }) => ({
//     width: '100%',
//     margin: theme.spacing(1, 0),
//     textTransform: 'none',
//     borderRadius: theme.shape.borderRadius * 1.5,
//     fontSize: 'clamp(1rem, 3vw, 1.1rem)',
//     fontWeight: 500,
//     padding: theme.spacing(1.5, 2.5),
//     justifyContent: 'flex-start',
//     transition: 'all 0.25s ease',
//     boxShadow: selected ? theme.shadows[2] : theme.shadows[1],
//     '&:hover': {
//         transform: 'scale(1.02)',
//         boxShadow: theme.shadows[4],
//     },
//     ...(showFeedback && {
//         pointerEvents: 'none',
//         ...(isCorrect && {
//             backgroundColor: alpha(theme.palette.success.light, 0.8),
//             color: theme.palette.success.contrastText,
//             '&:hover': { backgroundColor: theme.palette.success.main }
//         }),
//         ...(selected && !isCorrect && {
//             backgroundColor: alpha(theme.palette.error.light, 0.8),
//             color: theme.palette.error.contrastText,
//             '&:hover': { backgroundColor: theme.palette.error.main }
//         }),
//         ...(!selected && !isCorrect && {
//             backgroundColor: theme.palette.grey[300],
//             color: theme.palette.text.secondary,
//         })
//     }),
//     ...(!showFeedback && selected && {
//         backgroundColor: alpha(theme.palette.primary.light, 0.7),
//         color: theme.palette.primary.contrastText,
//         '&:hover': { backgroundColor: theme.palette.primary.main }
//     }),
//     opacity: quizCompleted && !selected && !isCorrect ? 0.6 : 1,
// }));

// const ActionButton = styled(Button)(({ theme }) => ({
//     padding: theme.spacing(1.5, 3),
//     borderRadius: theme.shape.borderRadius * 1.5,
//     fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
//     fontWeight: 'bold',
//     transition: 'all 0.3s ease',
//     boxShadow: theme.shadows[2],
//     '&:hover': {
//         boxShadow: theme.shadows[4],
//         transform: 'translateY(-2px)',
//     },
// }));

// const StatsCard = styled(Paper)(({ theme }) => ({
//     backgroundColor: alpha(theme.palette.background.paper, 0.9),
//     backdropFilter: 'blur(8px)',
//     borderRadius: theme.shape.borderRadius * 2.5,
//     padding: theme.spacing(3),
//     boxShadow: theme.shadows[3],
//     border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
// }));

// const ProgressCircle = styled(CircularProgress)(({ theme }) => ({
//     circle: { strokeLinecap: 'round' }
// }));

// // ========== Helper Functions ==========
// const formatTime = (sec) => {
//     const hrs = String(Math.floor(sec / 3600)).padStart(2, '0');
//     const min = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
//     const secStr = String(sec % 60).padStart(2, '0');
//     return `${hrs}:${min}:${secStr}`;
// };

// const calculateScore = (answers, questions) => {
//     return questions.reduce((score, q) => (
//         answers[q.id] === q.correctAnswer ? score + difficultyLevels[q.difficulty].points : score
//     ), 0);
// };

// const calculateMaxScore = (questions) => {
//     return questions.reduce((total, q) => total + difficultyLevels[q.difficulty].points, 0);
// };

// // ========== Main Component ==========
// const QuizApp = () => {
//     const theme = useTheme();
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//     const [answers, setAnswers] = useState({});
//     const [quizCompleted, setQuizCompleted] = useState(false);
//     const [timeLeftToday, setTimeLeftToday] = useState(QUIZ_AVAILABILITY_DURATION);
//     const [showFeedback, setShowFeedback] = useState(false);
//     const [openResult, setOpenResult] = useState({});
//     const [questionTimer, setQuestionTimer] = useState(QUESTION_DURATION);
//     const [isQuizActive, setIsQuizActive] = useState(false);
//     const [userStats, setUserStats] = useState(() => {
//         const savedStats = localStorage.getItem('quizUserStats');
//         return savedStats ? JSON.parse(savedStats) : {
//             completedQuizzes: 0,
//             totalPoints: 0,
//             streakDays: 0,
//             lastCompleted: null
//         };
//     });

//     const availabilityTimerRef = useRef(null);
//     const questionTimerRef = useRef(null);

//     // Initialize and clean up timers
//     useEffect(() => {
//         availabilityTimerRef.current = setInterval(() => {
//             setTimeLeftToday(prev => (prev > 0 ? prev - 1 : 0));
//         }, 1000);

//         return () => {
//             clearInterval(availabilityTimerRef.current);
//             clearInterval(questionTimerRef.current);
//         };
//     }, []);

//     // Handle question timer
//     useEffect(() => {
//         if (isQuizActive && questionTimer > 0) {
//             questionTimerRef.current = setInterval(() => {
//                 setQuestionTimer(prev => prev - 1);
//             }, 1000);
//         } else if (isQuizActive && questionTimer === 0) {
//             handleNextQuestion();
//         }
//         return () => clearInterval(questionTimerRef.current);
//     }, [isQuizActive, questionTimer, currentQuestionIndex]);

//     // Save user stats to localStorage
//     useEffect(() => {
//         localStorage.setItem('quizUserStats', JSON.stringify(userStats));
//     }, [userStats]);

//     const startQuiz = () => {
//         setIsQuizActive(true);
//         setQuestionTimer(QUESTION_DURATION);
//     };

//     const handleAnswer = (option) => {
//         if (isQuizActive && !showFeedback) {
//             const currentQ = mockQuestions[currentQuestionIndex];
//             setAnswers(prev => ({ ...prev, [currentQ.id]: option }));
//             setShowFeedback(true);
//         }
//     };

//     const handleNextQuestion = useCallback(() => {
//         if (showFeedback) {
//             setShowFeedback(false);
//             if (currentQuestionIndex < mockQuestions.length - 1) {
//                 setCurrentQuestionIndex(i => i + 1);
//                 setQuestionTimer(QUESTION_DURATION);
//             } else {
//                 completeQuiz();
//             }
//         }
//     }, [showFeedback, currentQuestionIndex]);

//     const completeQuiz = () => {
//         setQuizCompleted(true);
//         setIsQuizActive(false);
//         clearInterval(questionTimerRef.current);
        
//         // Calculate points earned
//         const pointsEarned = calculateScore(answers, mockQuestions);
//         const passed = pointsEarned >= (calculateMaxScore(mockQuestions) * PASSING_SCORE);
        
//         // Update user stats
//         const today = new Date().toISOString().split('T')[0];
//         const lastCompleted = userStats.lastCompleted;
//         const isNewDay = lastCompleted !== today;
        
//         setUserStats(prev => ({
//             completedQuizzes: prev.completedQuizzes + (passed ? 1 : 0),
//             totalPoints: prev.totalPoints + pointsEarned,
//             streakDays: isNewDay ? (passed ? prev.streakDays + 1 : 0) : prev.streakDays,
//             lastCompleted: today
//         }));
//     };

//     const handleRestartQuiz = () => {
//         setCurrentQuestionIndex(0);
//         setAnswers({});
//         setQuizCompleted(false);
//         setShowFeedback(false);
//         setQuestionTimer(QUESTION_DURATION);
//         setIsQuizActive(true);
//     };

//     const handleResultToggle = (id) => {
//         setOpenResult(prev => ({ ...prev, [id]: !prev[id] }));
//     };

//     const currentQ = mockQuestions[currentQuestionIndex];
//     const selectedAnswer = answers[currentQ?.id];
//     const correctAnswersCount = mockQuestions.reduce((count, q) => (
//         answers[q.id] === q.correctAnswer ? count + 1 : count
//     ), 0);
//     const questionProgress = ((currentQuestionIndex + 1) / mockQuestions.length) * 100;
//     const certificateProgress = (userStats.completedQuizzes / TOTAL_REQUIRED_FOR_CERTIFICATE) * 100;
//     const isQuizAvailable = timeLeftToday > 0;
//     const score = calculateScore(answers, mockQuestions);
//     const maxScore = calculateMaxScore(mockQuestions);
//     const passed = quizCompleted && score >= (maxScore * PASSING_SCORE);

//     // ========== Render Functions ==========
//     const renderQuizStart = () => (
//         <Box textAlign="center">
//             <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
//                 Ready for today's challenge?
//             </Typography>
//             <ActionButton
//                 variant="contained"
//                 color="primary"
//                 startIcon={<AlarmOn />}
//                 onClick={startQuiz}
//             >
//                 Start Today's Quiz
//             </ActionButton>
//             <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//                 Each question has {Math.floor(QUESTION_DURATION / 60)} minutes to answer.
//             </Typography>
//         </Box>
//     );

//     const renderQuizQuestion = () => (
//         <Box>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                 <Typography variant="h6" color="text.secondary">
//                     Question {currentQuestionIndex + 1} of {mockQuestions.length}
//                 </Typography>
//                 <Chip
//                     icon={<Category />}
//                     label={`${currentQ.category} • ${currentQ.difficulty}`}
//                     color={difficultyLevels[currentQ.difficulty].color}
//                     size="small"
//                 />
//             </Box>
            
//             <LinearProgress
//                 variant="determinate"
//                 value={questionProgress}
//                 sx={{ height: 10, borderRadius: 5, mb: 3 }}
//             />
            
//             <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
//                 {currentQ.question}
//             </Typography>
            
//             <Box mb={3}>
//                 {currentQ.options.map((opt, i) => (
//                     <OptionButton
//                         key={i}
//                         selected={selectedAnswer === opt}
//                         onClick={() => handleAnswer(opt)}
//                         quizCompleted={quizCompleted}
//                         isCorrect={opt === currentQ.correctAnswer}
//                         showFeedback={showFeedback}
//                         disabled={questionTimer === 0}
//                     >
//                         {opt}
//                     </OptionButton>
//                 ))}
//             </Box>
            
//             <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
//                 <ActionButton
//                     variant="outlined"
//                     color="warning"
//                     startIcon={<Refresh />}
//                     onClick={handleRestartQuiz}
//                     disabled={quizCompleted || questionTimer === 0}
//                 >
//                     Restart Quiz
//                 </ActionButton>
                
//                 <ActionButton
//                     onClick={handleNextQuestion}
//                     disabled={!showFeedback || questionTimer === 0}
//                     variant="contained"
//                     color="primary"
//                     endIcon={<ArrowForward />}
//                 >
//                     {currentQuestionIndex < mockQuestions.length - 1 ? 'Next Question' : 'Finish Quiz'}
//                 </ActionButton>
//             </Box>
            
//             {questionTimer > 0 && (
//                 <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, textAlign: 'right' }}>
//                     <Timer sx={{ verticalAlign: 'middle', mr: 1 }} />
//                     {Math.floor(questionTimer / 60)}:{String(questionTimer % 60).padStart(2, '0')}
//                 </Typography>
//             )}
            
//             {questionTimer === 0 && (
//                 <Alert severity="warning" sx={{ mt: 2 }}>
//                     Time's up! The answer to this question will be marked incorrect.
//                 </Alert>
//             )}
//         </Box>
//     );

//     const renderQuizResults = () => (
//         <Box sx={{ textAlign: 'center', py: 3 }}>
//             <EmojiEvents sx={{ fontSize: 100, color: passed ? 'gold' : 'grey.500', mb: 2 }} />
//             <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
//                 {passed ? 'Quiz Passed!' : 'Quiz Completed'}
//             </Typography>
//             <Typography variant="h5" sx={{ mb: 3 }}>
//                 You scored {score} out of {maxScore} points!
//             </Typography>

//             <Divider sx={{ my: 3 }}>
//                 <Chip label="Detailed Results" icon={<Info />} />
//             </Divider>

//             <List sx={{ maxHeight: 400, overflow: 'auto' }}>
//                 {mockQuestions.map((q) => (
//                     <Card key={q.id} sx={{ mb: 2, boxShadow: 1 }}>
//                         <ListItem button onClick={() => handleResultToggle(q.id)}>
//                             <ListItemIcon>
//                                 {answers[q.id] === q.correctAnswer ? (
//                                     <CheckCircle color="success" />
//                                 ) : (
//                                     <Close color="error" />
//                                 )}
//                             </ListItemIcon>
//                             <ListItemText
//                                 primary={q.question}
//                                 secondary={`Your answer: ${answers[q.id] || "Not answered"}`}
//                             />
//                             {openResult[q.id] ? <ExpandLess /> : <ExpandMore />}
//                         </ListItem>
//                         <Collapse in={openResult[q.id]} timeout="auto" unmountOnExit>
//                             <CardContent sx={{ pt: 0 }}>
//                                 <Typography variant="body2" sx={{ mt: 1 }}>
//                                     Correct Answer: <strong>{q.correctAnswer}</strong>
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
//                                     <Lightbulb sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
//                                     {q.explanation}
//                                 </Typography>
//                                 <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
//                                     <Star sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
//                                     <em>Fun Fact:</em> {q.funFact}
//                                 </Typography>
//                             </CardContent>
//                         </Collapse>
//                     </Card>
//                 ))}
//             </List>

//             <ActionButton
//                 startIcon={<Replay />}
//                 onClick={() => window.location.reload()}
//                 variant="outlined"
//                 color="secondary"
//                 sx={{ mt: 4 }}
//             >
//                 Try Again Tomorrow
//             </ActionButton>
//         </Box>
//     );

//     const renderQuizUnavailable = () => (
//         <Box textAlign="center" py={4}>
//             <AlarmOff sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
//             <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
//                 Today's Quiz Missed!
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//                 The daily quiz was available for 24 hours. Please come back tomorrow for the next quiz.
//             </Typography>
//         </Box>
//     );

//     const renderStatsCard = () => (
//         <StatsCard>
//             {/* Time Left Section */}
//             <Box display="flex" alignItems="center" gap={1.5} sx={{ mb: 3, pb: 2 }}>
//                 <AccessTime sx={{ color: 'secondary.main', fontSize: 32 }} />
//                 <Typography variant="h6">Time Left Today</Typography>
//                 <Typography variant="h6" sx={{ ml: 'auto', fontWeight: 'bold' }}>
//                     {formatTime(Math.max(0, timeLeftToday))}
//                 </Typography>
//             </Box>

//             {/* Certificate Progress */}
//             <Box textAlign="center">
//                 <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
//                     Certificate Progress
//                 </Typography>
//                 <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
//                     <ProgressCircle
//                         variant="determinate"
//                         value={Math.min(certificateProgress, 100)}
//                         size={160}
//                         thickness={6}
//                         sx={{ color: 'warning.main' }}
//                     />
//                     <Box
//                         sx={{
//                             top: 0, left: 0, bottom: 0, right: 0,
//                             position: 'absolute',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             flexDirection: 'column',
//                         }}
//                     >
//                         <School sx={{ color: 'warning.dark', fontSize: 30, mb: 0.5 }} />
//                         <Typography variant="h4" component="div">
//                             {`${Math.round(Math.min(certificateProgress, 100))}%`}
//                         </Typography>
//                     </Box>
//                 </Box>
//                 <Typography variant="subtitle1" sx={{ mt: 1 }}>
//                     {userStats.completedQuizzes} / {TOTAL_REQUIRED_FOR_CERTIFICATE} Quizzes Completed
//                 </Typography>
//             </Box>

//             {/* User Stats */}
//             <Box sx={{ mt: 4 }}>
//                 <Typography variant="h6" gutterBottom>
//                     Your Stats
//                 </Typography>
//                 <Grid container spacing={2}>
//                     <Grid item xs={6}>
//                         <Paper sx={{ p: 2, textAlign: 'center' }}>
//                             <TrendingUp sx={{ fontSize: 30, color: 'success.main', mb: 1 }} />
//                             <Typography variant="h6">{userStats.totalPoints}</Typography>
//                             <Typography variant="body2">Total Points</Typography>
//                         </Paper>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Paper sx={{ p: 2, textAlign: 'center' }}>
//                             <Leaderboard sx={{ fontSize: 30, color: 'info.main', mb: 1 }} />
//                             <Typography variant="h6">{userStats.streakDays}</Typography>
//                             <Typography variant="body2">Day Streak</Typography>
//                         </Paper>
//                     </Grid>
//                 </Grid>
//             </Box>

//             {/* Certificate Unlocked Alert */}
//             {userStats.completedQuizzes >= TOTAL_REQUIRED_FOR_CERTIFICATE && (
//                 <Alert
//                     severity="success"
//                     icon={<Celebration fontSize="inherit" />}
//                     sx={{ mt: 3, borderRadius: 2 }}
//                 >
//                     <AlertTitle>Certificate Unlocked!</AlertTitle>
//                     Congratulations! You've earned your achievement certificate.
//                 </Alert>
//             )}
//         </StatsCard>
//     );

//     // ========== Main Render ==========
//     return (
//         <AppContainer>
//             <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
//                 {/* Main Quiz Card */}
//                 <Grid item xs={12} md={7} lg={8}>
//                     <QuizCard>
//                         <QuizHeader
//                             avatar={<Quiz sx={{ color: 'primary.main', fontSize: 50 }} />}
//                             title="Knowledge Quest Daily"
//                             subheader="Sharpen your mind, one question at a time!"
//                         />
//                         <CardContent>
//                             {isQuizAvailable ? (
//                                 !isQuizActive ? (
//                                     renderQuizStart()
//                                 ) : !quizCompleted ? (
//                                     renderQuizQuestion()
//                                 ) : (
//                                     renderQuizResults()
//                                 )
//                             ) : (
//                                 renderQuizUnavailable()
//                             )}
//                         </CardContent>
//                     </QuizCard>
//                 </Grid>

//                 {/* Sidebar Stats */}
//                 <Grid item xs={12} md={5} lg={4}>
//                     {renderStatsCard()}
//                 </Grid>
//             </Grid>
//         </AppContainer>
//     );
// };

// export default QuizApp;



import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import {
  Box, Button, Card, CardContent, CardHeader, Typography, Grid, CircularProgress,
  LinearProgress, List, ListItem, ListItemIcon, ListItemText, Collapse, Chip,
  Paper, Divider, Alert, AlertTitle, Avatar, Badge, Tooltip, IconButton
} from '@mui/material';
import { styled, alpha, useTheme } from '@mui/material/styles';
import {
  Quiz, ArrowForward, Replay, AccessTime, EmojiEvents, CheckCircle, Close,
  School, ExpandMore, ExpandLess, Category, Lightbulb, Refresh, Info,
  Celebration, AlarmOn, AlarmOff, Timer, Star, HelpOutline, LockClock,
  TrendingUp, Leaderboard
} from '@mui/icons-material';

// Assuming baseUrl is defined in a config file like '../config'
// For this self-contained example, we'll mock it or you can replace it
// with your actual backend URL.
import baseUrl from '../../config';

// Constants (aligned with backend)
const QUESTION_DURATION = 120; // Seconds per question
const QUIZ_AVAILABILITY_DURATION_SECONDS = 86400; // 24 hours in seconds
const TOTAL_REQUIRED_FOR_CERTIFICATE = 4;
const PASSING_SCORE = 0.7;
const difficultyLevels = {
  easy: { color: 'success', points: 10 },
  medium: { color: 'warning', points: 20 },
  hard: { color: 'error', points: 30 }
};

// Styled Components
const AppContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  padding: theme.spacing(2),
  background: 'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',
  [theme.breakpoints.up('sm')]: { padding: theme.spacing(4) },
}));

const QuizCard = styled(Card)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius * 3,
  boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 18px 36px rgba(0, 0, 0, 0.2)' },
  maxWidth: 800,
  margin: '0 auto',
}));

const QuizHeader = styled(CardHeader)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
  '& .MuiCardHeader-title': { fontSize: 'clamp(1.5rem, 4vw, 2rem)', fontWeight: 700, color: theme.palette.primary.dark },
  '& .MuiCardHeader-subheader': { fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)', color: theme.palette.text.secondary },
}));

const OptionButton = styled(Button, {
  shouldForwardProp: (prop) => !['selected', 'isCorrect', 'quizCompleted', 'showFeedback'].includes(prop)
})(({ theme, selected, isCorrect, quizCompleted, showFeedback }) => ({
  width: '100%',
  margin: theme.spacing(1, 0),
  textTransform: 'none',
  borderRadius: theme.shape.borderRadius * 1.5,
  fontSize: 'clamp(1rem, 3vw, 1.1rem)',
  fontWeight: 500,
  padding: theme.spacing(1.5, 2.5),
  justifyContent: 'flex-start',
  transition: 'all 0.25s ease',
  boxShadow: selected ? theme.shadows[2] : theme.shadows[1],
  '&:hover': { transform: 'scale(1.02)', boxShadow: theme.shadows[4] },
  ...(showFeedback && {
    pointerEvents: 'none', // Disable clicks after feedback is shown
    ...(isCorrect && {
      backgroundColor: alpha(theme.palette.success.light, 0.8),
      color: theme.palette.success.contrastText,
      '&:hover': { backgroundColor: theme.palette.success.main }
    }),
    ...(selected && !isCorrect && {
      backgroundColor: alpha(theme.palette.error.light, 0.8),
      color: theme.palette.error.contrastText,
      '&:hover': { backgroundColor: theme.palette.error.main }
    }),
    ...(!selected && !isCorrect && {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.text.secondary,
    })
  }),
  ...(!showFeedback && selected && {
    backgroundColor: alpha(theme.palette.primary.light, 0.7),
    color: theme.palette.primary.contrastText,
    '&:hover': { backgroundColor: theme.palette.primary.main }
  }),
  opacity: quizCompleted && !selected && !isCorrect ? 0.6 : 1,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.shape.borderRadius * 1.5,
  fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
  fontWeight: 'bold',
  transition: 'all 0.3s ease',
  boxShadow: theme.shadows[2],
  '&:hover': { boxShadow: theme.shadows[4], transform: 'translateY(-2px)' },
}));

const StatsCard = styled(Paper)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.background.paper, 0.9),
  backdropFilter: 'blur(8px)',
  borderRadius: theme.shape.borderRadius * 2.5,
  padding: theme.spacing(3),
  boxShadow: theme.shadows[3],
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
}));

const ProgressCircle = styled(CircularProgress)(({ theme }) => ({
  circle: { strokeLinecap: 'round' }
}));

// Helper Functions
const formatTime = (sec) => {
  const hrs = String(Math.floor(sec / 3600)).padStart(2, '0');
  const min = String(Math.floor((sec % 3600) / 60)).padStart(2, '0');
  const secStr = String(sec % 60).padStart(2, '0');
  return `${hrs}:${min}:${secStr}`;
};

const calculateScore = (answers, questions) => {
  return questions.reduce((score, q) => (
    answers[q._id]?.selectedAnswer === q.correctAnswer ? score + difficultyLevels[q.difficulty].points : score
  ), 0);
};

const calculateMaxScore = (questions) => {
  return questions.reduce((total, q) => total + difficultyLevels[q.difficulty].points, 0);
};

const QuizApp = () => {
  const theme = useTheme();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [timeLeftToday, setTimeLeftToday] = useState(QUIZ_AVAILABILITY_DURATION_SECONDS);
  const [showFeedback, setShowFeedback] = useState(false);
  const [openResult, setOpenResult] = useState({});
  const [questionTimer, setQuestionTimer] = useState(QUESTION_DURATION);
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [dailyQuiz, setDailyQuiz] = useState(null);
  const [userStats, setUserStats] = useState({
    completedQuizzes: 0,
    totalPoints: 0,
    streakDays: 0,
    lastCompleted: null,
    certificates: [], // Assuming certificates is an array of objects with an 'achieved' property
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorType, setErrorType] = useState(null); // New state to identify specific error types

  const availabilityTimerRef = useRef(null);
  const questionTimerRef = useRef(null);
  const questionStartTimeRef = useRef(Date.now()); // To track start time for each question

  // submitQuiz must be declared before handleNextQuestion because handleNextQuestion depends on it
  const submitQuiz = useCallback(async () => {
    try {
      setQuizCompleted(true);
      setIsQuizActive(false);
      clearInterval(questionTimerRef.current); // Ensure timer is cleared

      const answersArray = Object.entries(answers).map(([quizId, answer]) => ({
        quizId,
        selectedAnswer: answer.selectedAnswer,
        timeTaken: answer.timeTaken,
      }));

      const response = await axios.post(
        baseUrl + 'api/quiz/daily-quiz/submit',
        { dailyQuizId: dailyQuiz._id, answers: answersArray },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      const { score, passed } = response.data; // Backend should return `passed` status
      const maxScore = calculateMaxScore(dailyQuiz.questions); // Recalculate max score for display

      // Update user stats based on backend response
      // It's safer to re-fetch user stats after submission or rely on backend's response for updated stats
      // For simplicity, we'll update based on the response here, but a re-fetch might be more robust.
      const updatedUserStats = { ...userStats };
      updatedUserStats.completedQuizzes += passed ? 1 : 0;
      updatedUserStats.totalPoints += score;

      // Streak logic (simplified, backend should handle authoritative streak)
      const todayString = new Date().toISOString().split('T')[0];
      const lastCompletedString = userStats.lastCompleted ? new Date(userStats.lastCompleted).toISOString().split('T')[0] : null;

      if (todayString !== lastCompletedString) { // If it's a new day
        updatedUserStats.streakDays = passed ? (userStats.streakDays + 1) : 0;
      } else { // Same day, maintain streak if passed again
        updatedUserStats.streakDays = userStats.streakDays;
      }
      updatedUserStats.lastCompleted = new Date(); // Update last completed time

      // Check for certificate (backend is authoritative, but frontend can reflect)
      if (updatedUserStats.completedQuizzes >= TOTAL_REQUIRED_FOR_CERTIFICATE && !updatedUserStats.certificates.some(c => c.achieved)) {
        updatedUserStats.certificates.push({ achieved: true }); // Add a dummy certificate for display
      }

      setUserStats(updatedUserStats);

    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit quiz');
      // If submission fails, quiz is still completed, but score/stats might be off
      setQuizCompleted(true);
      setIsQuizActive(false);
    }
  }, [answers, dailyQuiz, userStats]); // Dependencies for useCallback

  const handleNextQuestion = useCallback(() => {
    clearInterval(questionTimerRef.current); // Clear timer for current question
    setShowFeedback(false); // Hide feedback for next question

    if (currentQuestionIndex < dailyQuiz.questions.length - 1) {
      setCurrentQuestionIndex(i => i + 1);
      setQuestionTimer(QUESTION_DURATION); // Reset timer for next question
      questionStartTimeRef.current = Date.now(); // Reset start time for next question
    } else {
      submitQuiz(); // All questions answered, submit the quiz
    }
  }, [currentQuestionIndex, dailyQuiz, submitQuiz]); // Added submitQuiz to dependencies


  // Fetch daily quiz and user stats
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null); // Clear previous errors
        setErrorType(null); // Clear previous error types

        const [quizResponse, statsResponse] = await Promise.all([
          axios.get(baseUrl + 'api/quiz/daily-quiz', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }),
          axios.get(baseUrl + 'api/quiz/user-stats', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }) // Fetch user-stats directly
        ]);

        // Assuming quizResponse.data is the DailyQuiz object directly or an array containing it
        const fetchedDailyQuiz = quizResponse.data.dailyQuiz || quizResponse.data; // Adjust based on your backend response structure
        
        if (fetchedDailyQuiz && fetchedDailyQuiz.questions && fetchedDailyQuiz.questions.length > 0) {
          setDailyQuiz(fetchedDailyQuiz);
          // Calculate time left from expiryDate provided by backend
          const expiry = fetchedDailyQuiz.expiryDate ? new Date(fetchedDailyQuiz.expiryDate) : null;
          if (expiry && expiry > new Date()) {
            setTimeLeftToday(Math.max(0, Math.floor((expiry - new Date()) / 1000)));
          } else {
            // If quiz already expired or no expiry date, mark as unavailable
            setTimeLeftToday(0);
          }

          // Check if quiz is already completed/missed
          if (fetchedDailyQuiz.status === 'completed' || fetchedDailyQuiz.status === 'missed') {
            setQuizCompleted(true); // Mark as completed to show results/unavailable message
            setIsQuizActive(false); // Ensure quiz is not active
            // If completed, populate answers to show results
            if (fetchedDailyQuiz.status === 'completed') {
                const completedAnswers = {};
                fetchedDailyQuiz.answers.forEach(ans => {
                    completedAnswers[ans.quizId] = { selectedAnswer: ans.selectedAnswer, timeTaken: ans.timeTaken, isCorrect: ans.isCorrect };
                });
                setAnswers(completedAnswers);
            }
          }
        } else {
          // If no daily quiz data or questions, it might mean no quiz available for today
          setError('No quiz available for today.');
        }

        const stats = statsResponse.data || {};
        setUserStats({
          completedQuizzes: stats.completedQuizzes || 0,
          totalPoints: stats.totalPoints || 0,
          streakDays: stats.streakDays || 0,
          lastCompleted: stats.lastCompleted || null,
          certificates: stats.certificates || [],
        });

      } catch (err) {
        const backendError = err.response?.data?.error;
        setError(backendError || 'Failed to load quiz or user stats. Please try again.');

        if (backendError === 'Not enough available quizzes for the student') {
          setErrorType('NOT_ENOUGH_QUIZZES');
        } else if (backendError === 'Unauthorized: Missing user info') {
            setErrorType('UNAUTHORIZED');
        }
        // Add more specific error types if needed
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Availability timer
  useEffect(() => {
    if (timeLeftToday > 0) {
      availabilityTimerRef.current = setInterval(() => {
        setTimeLeftToday(prev => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    } else {
      clearInterval(availabilityTimerRef.current);
    }
    return () => clearInterval(availabilityTimerRef.current);
  }, [timeLeftToday]); // Dependency on timeLeftToday to restart if it changes

  // Question timer
  useEffect(() => {
    if (isQuizActive && questionTimer > 0 && !showFeedback) {
      questionTimerRef.current = setInterval(() => {
        setQuestionTimer(prev => prev - 1);
      }, 1000);
    } else if (isQuizActive && questionTimer === 0 && !showFeedback) {
      // Time's up for current question, automatically move to next
      handleNextQuestion();
    }
    return () => clearInterval(questionTimerRef.current);
  }, [isQuizActive, questionTimer, showFeedback, currentQuestionIndex, handleNextQuestion]); // Added handleNextQuestion to dependencies


  const startQuiz = () => {
    setIsQuizActive(true);
    setQuestionTimer(QUESTION_DURATION);
    questionStartTimeRef.current = Date.now(); // Reset start time for the first question
  };

  const handleAnswer = (option) => {
    if (isQuizActive && !showFeedback) {
      const currentQ = dailyQuiz.questions[currentQuestionIndex];
      const timeTaken = Math.round((Date.now() - questionStartTimeRef.current) / 1000);
      setAnswers(prev => ({
        ...prev,
        [currentQ._id]: { selectedAnswer: option, timeTaken, isCorrect: option === currentQ.correctAnswer },
      }));
      setShowFeedback(true);
    }
  };


  const handleRestartQuiz = () => {
    setCurrentQuestionIndex(0);
    setAnswers({});
    setQuizCompleted(false);
    setShowFeedback(false);
    setQuestionTimer(QUESTION_DURATION);
    setIsQuizActive(true);
    questionStartTimeRef.current = Date.now(); // Reset start time for the first question
  };

  const handleResultToggle = (id) => {
    setOpenResult(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const renderQuizStart = () => (
    <Box textAlign="center" py={4}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Ready for today's quiz?
      </Typography>
      <ActionButton
        variant="contained"
        color="primary"
        startIcon={<AlarmOn />}
        onClick={startQuiz}
      >
        Start Today's Quiz
      </ActionButton>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Each question has {Math.floor(QUESTION_DURATION / 60)} minutes to answer.
      </Typography>
    </Box>
  );

  const renderQuizQuestion = () => {
    if (!dailyQuiz || !dailyQuiz.questions || dailyQuiz.questions.length === 0) return null; // Should ideally not happen here
    const currentQ = dailyQuiz.questions[currentQuestionIndex];
    const selectedAnswer = answers[currentQ._id]?.selectedAnswer;

    return (
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" color="text.secondary">
            Question {currentQuestionIndex + 1} of {dailyQuiz.questions.length}
          </Typography>
          <Chip
            icon={<Category />}
            label={`${currentQ.category} • ${currentQ.difficulty}`}
            color={difficultyLevels[currentQ.difficulty].color}
            size="small"
          />
        </Box>
        <LinearProgress
          variant="determinate"
          value={((currentQuestionIndex + 1) / dailyQuiz.questions.length) * 100}
          sx={{ height: 10, borderRadius: 5, mb: 3 }}
        />
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
          {currentQ.question}
        </Typography>
        <Box mb={3}>
          {currentQ.options.map((opt, i) => (
            <OptionButton
              key={i}
              selected={selectedAnswer === opt}
              onClick={() => handleAnswer(opt)} // Removed startTime as it's now a ref
              quizCompleted={quizCompleted}
              isCorrect={opt === currentQ.correctAnswer}
              showFeedback={showFeedback}
              disabled={showFeedback || questionTimer === 0} // Disable if feedback is shown or time is up
            >
              {opt}
            </OptionButton>
          ))}
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
          <ActionButton
            variant="outlined"
            color="warning"
            startIcon={<Refresh />}
            onClick={handleRestartQuiz}
            disabled={quizCompleted || showFeedback} // Disable restart if quiz is completed or feedback is showing
          >
            Restart Quiz
          </ActionButton>
          <ActionButton
            onClick={handleNextQuestion}
            disabled={!showFeedback && questionTimer > 0} // Disable if no answer selected yet and time is not up
            variant="contained"
            color="primary"
            endIcon={<ArrowForward />}
          >
            {currentQuestionIndex < dailyQuiz.questions.length - 1 ? 'Next Question' : 'Finish Quiz'}
          </ActionButton>
        </Box>
        {questionTimer > 0 && (
          <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, textAlign: 'right' }}>
            <Timer sx={{ verticalAlign: 'middle', mr: 1 }} />
            {Math.floor(questionTimer / 60)}:{String(questionTimer % 60).padStart(2, '0')}
          </Typography>
        )}
        {questionTimer === 0 && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Time's up! The answer to this question will be marked incorrect.
          </Alert>
        )}
      </Box>
    );
  };

  const renderQuizResults = () => {
    if (!dailyQuiz) return null;
    const score = calculateScore(answers, dailyQuiz.questions);
    const maxScore = calculateMaxScore(dailyQuiz.questions);
    const passed = score >= (maxScore * PASSING_SCORE);

    return (
      <Box sx={{ textAlign: 'center', py: 3 }}>
        <EmojiEvents sx={{ fontSize: 100, color: passed ? 'gold' : 'grey.500', mb: 2 }} />
        <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
          {passed ? 'Quiz Passed!' : 'Quiz Completed'}
        </Typography>
        <Typography variant="h5" sx={{ mb: 3 }}>
          You scored {score} out of {maxScore} points!
        </Typography>
        <Divider sx={{ my: 3 }}>
          <Chip label="Detailed Results" icon={<Info />} />
        </Divider>
        <List sx={{ maxHeight: 400, overflow: 'auto' }}>
          {dailyQuiz.questions.map((q) => (
            <Card key={q._id} sx={{ mb: 2, boxShadow: 1 }}>
              <ListItem button onClick={() => handleResultToggle(q._id)}>
                <ListItemIcon>
                  {answers[q._id]?.isCorrect ? ( // Use isCorrect from answers state
                    <CheckCircle color="success" />
                  ) : (
                    <Close color="error" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={q.question}
                  secondary={`Your answer: ${answers[q._id]?.selectedAnswer || "Not answered"}`}
                />
                {openResult[q._id] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse in={openResult[q._id]} timeout="auto" unmountOnExit>
                <CardContent sx={{ pt: 0 }}>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Correct Answer: <strong>{q.correctAnswer}</strong>
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                    <Lightbulb sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
                    {q.explanation}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
                    <Star sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} />
                    <em>Fun Fact:</em> {q.funFact}
                  </Typography>
                </CardContent>
              </Collapse>
            </Card>
          ))}
        </List>
        <ActionButton
          startIcon={<Replay />}
          onClick={() => window.location.reload()}
          variant="outlined"
          color="secondary"
          sx={{ mt: 4 }}
        >
          Try Again Tomorrow
        </ActionButton>
      </Box>
    );
  };

  const renderQuizUnavailable = () => (
    <Box textAlign="center" py={4}>
      <AlarmOff sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
        Today's Quiz Missed!
      </Typography>
      <Typography variant="body1" color="text.secondary">
        The daily quiz was available for 24 hours and has now expired. Please come back tomorrow for the next quiz.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Refresh />}
        onClick={() => window.location.reload()}
        sx={{ mt: 3 }}
      >
        Check for Tomorrow's Quiz
      </Button>
    </Box>
  );

  const renderNotEnoughQuizzes = () => (
    <Box textAlign="center" py={4}>
      <LockClock sx={{ fontSize: 100, color: 'info.main', mb: 2 }} />
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
        Oops! Not Enough Quizzes Yet!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        It looks like we don't have enough new questions tailored for you right now.
        This could be because you've completed most available quizzes or new content is being prepared.
        Please check back again later or tomorrow!
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Refresh />}
        onClick={() => window.location.reload()}
      >
        Refresh & Try Again
      </Button>
    </Box>
  );

  const renderStatsCard = () => {
    const hasCertificate = userStats.certificates.some(c => c.achieved);
    return (
      <StatsCard>
        <Box display="flex" alignItems="center" gap={1.5} sx={{ mb: 3, pb: 2 }}>
          <AccessTime sx={{ color: 'secondary.main', fontSize: 32 }} />
          <Typography variant="h6">Time Left Today</Typography>
          <Typography variant="h6" sx={{ ml: 'auto', fontWeight: 'bold' }}>
            {formatTime(Math.max(0, timeLeftToday))}
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Certificate Progress
          </Typography>
          <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
            <ProgressCircle
              variant="determinate"
              value={Math.min((userStats.completedQuizzes / TOTAL_REQUIRED_FOR_CERTIFICATE) * 100, 100)}
              size={160}
              thickness={6}
              sx={{ color: 'warning.main' }}
            />
            <Box
              sx={{
                top: 0, left: 0, bottom: 0, right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <School sx={{ color: 'warning.dark', fontSize: 30, mb: 0.5 }} />
              <Typography variant="h4" component="div">
                {`${Math.round(Math.min((userStats.completedQuizzes / TOTAL_REQUIRED_FOR_CERTIFICATE) * 100, 100))}%`}
              </Typography>
            </Box>
          </Box>
          <Typography variant="subtitle1" sx={{ mt: 1 }}>
            {userStats.completedQuizzes} / {TOTAL_REQUIRED_FOR_CERTIFICATE} Quizzes Passed
          </Typography>
        </Box>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            Your Stats
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <TrendingUp sx={{ fontSize: 30, color: 'success.main', mb: 1 }} />
                <Typography variant="h6">{userStats.totalPoints}</Typography>
                <Typography variant="body2">Total Points</Typography>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper sx={{ p: 2, textAlign: 'center' }}>
                <Leaderboard sx={{ fontSize: 30, color: 'info.main', mb: 1 }} />
                <Typography variant="h6">{userStats.streakDays}</Typography>
                <Typography variant="body2">Day Streak</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        {hasCertificate && (
          <Alert
            severity="success"
            icon={<Celebration fontSize="inherit" />}
            sx={{ mt: 3, borderRadius: 2 }}
          >
            <AlertTitle>Certificate Unlocked!</AlertTitle>
            Congratulations! You've earned your achievement certificate.
          </Alert>
        )}
      </StatsCard>
    );
  };

  // --- Main Render Logic ---
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 font-sans p-6">
        <div className="flex flex-col items-center p-8 bg-white rounded-3xl shadow-xl">
          <div className="animate-bounce bg-blue-500 p-4 rounded-full mb-4">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
          </div>
          <p className="text-xl text-gray-700 font-semibold">Loading Quiz and Stats....</p>
        </div>
      </div>
    );
  }
  // Specific error for not enough quizzes
  if (errorType === 'NOT_ENOUGH_QUIZZES') {
    return (
      <AppContainer>
        <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
          <Grid item xs={12} md={7} lg={8}>
            <QuizCard>
              <CardContent>
                {renderNotEnoughQuizzes()}
              </CardContent>
            </QuizCard>
          </Grid>
          <Grid item xs={12} md={5} lg={4}>
            {renderStatsCard()}
          </Grid>
        </Grid>
      </AppContainer>
    );
  }

  // General error message
  if (error) return (
    <AppContainer>
      <Grid container spacing={3} justifyContent="center" alignItems="center" style={{ minHeight: '80vh' }}>
        <Grid item xs={12} md={8}>
          <Alert severity="error" sx={{ borderRadius: 2, p: 3 }}>
            <AlertTitle>Error Loading Quiz</AlertTitle>
            {error}
            <Box mt={2}>
                <Button onClick={() => window.location.reload()} variant="outlined" color="error" startIcon={<Refresh />}>
                    Try Again
                </Button>
            </Box>
          </Alert>
        </Grid>
      </Grid>
    </AppContainer>
  );

  // No quiz available (but not an error, e.g., already completed or no new quiz for today)
  if (!dailyQuiz || dailyQuiz.questions.length === 0) return (
    <AppContainer>
        <Grid container spacing={3} justifyContent="center" alignItems="center" style={{ minHeight: '80vh' }}>
            <Grid item xs={12} md={8}>
                <Alert severity="info" sx={{ borderRadius: 2, p: 3 }}>
                    <AlertTitle>No Quiz Available Today</AlertTitle>
                    It seems there isn't a new daily quiz for you right now. Please check back later!
                    <Box mt={2}>
                        <Button onClick={() => window.location.reload()} variant="outlined" color="info" startIcon={<Refresh />}>
                            Refresh
                        </Button>
                    </Box>
                </Alert>
            </Grid>
        </Grid>
    </AppContainer>
);

  // Main quiz display
  return (
    <AppContainer>
      <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
        <Grid item xs={12} md={7} lg={8}>
          <QuizCard>
            <QuizHeader
              avatar={<Quiz sx={{ color: 'primary.main', fontSize: 50 }} />}
              title="Daily Quiz"
              subheader="Sharpen your mind, one question at a time!"
            />
            <CardContent>
              {timeLeftToday > 0 && !quizCompleted ? ( // Quiz is available and not yet completed/missed
                !isQuizActive ? (
                  renderQuizStart()
                ) : (
                  renderQuizQuestion()
                )
              ) : ( // Quiz is either completed, missed, or time ran out
                quizCompleted ? ( // If quiz was completed (either passed or failed)
                    renderQuizResults()
                ) : ( // If quiz was active but time ran out (missed)
                    renderQuizUnavailable()
                )
              )}
            </CardContent>
          </QuizCard>
        </Grid>
        <Grid item xs={12} md={5} lg={4}>
          {renderStatsCard()}
        </Grid>
      </Grid>
    </AppContainer>
  );
};

export default QuizApp;
